// FILE: src/utils/firebase/features/rules/fetchers.js

import { fetchByEmailOnce, subscribeByEmailHelper } from "../../core/emailScoped";
import { COLLECTIONS } from "../../core/collections";
import { DEFAULT_CAP } from "../../core/firestoreCore";
import { getOrFetch, getOrFetchWithMeta, invalidate as _invalidate } from "../../cache/getOrFetch";

/* ---------- TTLs ---------- */
const TTL_USER_RULES = Number(process.env.REACT_APP_TTL_USER_RULES_MS) || 60 * 60 * 1000; // 1h

export function subscribeUserRules({ userEmail, cap = DEFAULT_CAP, onData, onError }) {
  return subscribeByEmailHelper({
    colName: COLLECTIONS.userRules,
    userEmail,
    cap,
    extra: [],
    onData,
    onError,
  });
}

export function fetchUserRulesOnce(userEmail, opts = {}) {
  if (opts?.noCache) return fetchByEmailOnce(COLLECTIONS.userRules, userEmail, opts);
  const key = `rules:${userEmail}`;
  return getOrFetch({
    key,
    ttlMs: opts.ttlMs ?? TTL_USER_RULES,
    persist: true,
    persistKey: key,
    fetcher: () => fetchByEmailOnce(COLLECTIONS.userRules, userEmail, opts),
  });
}

/* New: meta variant for pill */
export async function fetchUserRulesOnceWithMeta(userEmail, opts = {}) {
  if (opts?.noCache) {
    const value = await fetchByEmailOnce(COLLECTIONS.userRules, userEmail, opts);
    return { value, fromCache: false };
  }
  const key = `rules:${userEmail}`;
  return getOrFetchWithMeta({
    key,
    ttlMs: opts.ttlMs ?? TTL_USER_RULES,
    persist: true,
    persistKey: key,
    fetcher: () => fetchByEmailOnce(COLLECTIONS.userRules, userEmail, opts),
  });
}

/* ---------- Cache Invalidator ---------- */
export function invalidateUserRulesCache(userEmail) {
  _invalidate(`rules:${userEmail}`);
}
